import { useEffect, useMemo } from "react";
import { useSelector } from "react-redux";
import { useFormContext } from "react-hook-form";

// Components
import CurrencySelectMobile from "components/molecules/CurrencySelectMobile";

// Hooks
import { useCurrency } from "hooks/useCurrency";

// Selectors
import * as wheelSelector from "redux/landing/wheels/selectors";
import { useCatalogsStore } from "stores/catalogs";
import { useGTM } from "../../hooks/useGTM";

const CurrencySelectMobileContainer = () => {
  const currencies = useCatalogsStore((state) => state.currencies);
  const defaultCurrency = useCurrency();
  const GTM = useGTM();
  const { getValues, setValue } = useFormContext();
  const { type } = useSelector(wheelSelector.all);

  useEffect(() => {
    if (defaultCurrency) {
      setValue("currencyCode", defaultCurrency);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultCurrency]);

  const handleSelect = (currency: string) => {
    const currencyCode = getValues("currencyCode");
    GTM.clickWheelCurrencyСhoice(currency);
    if (currencyCode === currency) {
      setValue("currencyCode", "");
    } else {
      setValue("currencyCode", currency);
    }
  };

  const currencyList = useMemo<string[]>(() => {
    if (currencies) {
      return currencies?.map((item) => item.isoCode);
    }
    return [];
  }, [currencies]);

  return (
    <CurrencySelectMobile
      type={type}
      list={currencyList}
      onSelect={handleSelect}
    />
  );
};

export default CurrencySelectMobileContainer;
